/**
 * Pre-payment legal disclosure — the single source of truth for the exact
 * text and version shown to users on the checkout screen. When the user
 * initiates a payment we snapshot this text + version into the immutable
 * `payment_consents` MongoDB collection alongside the transaction, giving
 * us watertight evidence for chargebacks or consumer disputes.
 *
 * IMPORTANT: bump `DISCLAIMER_VERSION` any time you change the wording —
 * historic records must keep pointing at the exact string a given user
 * saw, and the version lets us reconstruct which text was in force at any
 * moment in the past.
 */
export const DISCLAIMER_VERSION = "v1.0";

export const DISCLAIMER_TEXT =
  "I understand that AdmissionCrafts provides a prediction based on historical MHT-CET CAP data and is not a guarantee of admission, college, or branch.";

// Signup-time parent/guardian self-declaration. Under Clause 3 of the Terms
// (26 Feb 2026) the account must be operated by a parent/legal guardian, or
// by a 16-17-year-old student under their supervision. This declaration is
// captured once at account creation and stored immutably in the
// `user_declarations` MongoDB collection alongside IP + user-agent.
export const GUARDIAN_DECLARATION_VERSION = "v1.0";

export const GUARDIAN_DECLARATION_TEXT =
  "I confirm that I am the parent or legal guardian of the student (aged 18+), or that a parent/legal guardian is supervising and consenting to this account being used by a student aged 16 or 17. I have read and accept the Terms & Conditions and Privacy Policy.";

// Versions of the referenced policies at the time this disclosure text was
// last reviewed. Kept in sync with the "Last updated:" line on /terms and
// /refund. Persisted alongside every consent so any future policy change
// is audit-traceable.
export const TERMS_VERSION_IN_EFFECT = "26 February 2026";
export const REFUND_POLICY_VERSION_IN_EFFECT = "01 July 2026";
